import { BasiqActions } from "./basiq.actions";
import { InstitutionView } from "../../../../models/view/institution/institution.view";
import { BasiqInstitutionMapper } from "../mappers/basiq.mapper.institution";
import { inject, Injectable } from "@angular/core";
import { SyncStatusEnum } from "@bitwarden/web-vault/app/models/types/general-types";

@Injectable({
  providedIn: "root",
})
export class BasiqInstitutionAction extends BasiqActions {
  private institutionMapper: BasiqInstitutionMapper;
  syncStatus: SyncStatusEnum;

  constructor() {
    super();
    this.institutionMapper = inject(BasiqInstitutionMapper);
  }

  async saveInstitutions() {
    try {
      this.appState.startProcess("importing-data", "Saving your institutions");
      const newInstitutions: InstitutionView[] = [];
      const userInstitutions = this.userStore.institutions.institutionViews();
      const connectionsResponse = await this.basiqAuthApi.connections();

      for (const connection of connectionsResponse.connections) {
        const connectionResponse = await this.basiqAuthApi.connectionById(connection.id);
        const basiqInstitution = connectionResponse.connection.institution;
        const institutionExists = userInstitutions?.some(
          (institution) => institution.instoBasiqId === basiqInstitution.id,
        );

        if (!institutionExists) {
          const institutionResponse = await this.basiqDataApi.institutionById(basiqInstitution.id);
          const institutionToSave = await this.institutionMapper.map(
            institutionResponse.institution,
          );
          newInstitutions.push(institutionToSave);
        }
      }

      if (newInstitutions.length) {
        const isSaved = await this.userStore.institutions.saveToVault(newInstitutions, true);
        this.appState.endProcess("importing-data");
        return isSaved;
      }

      this.appState.endProcess("importing-data");
      return true;
    } catch (error) {
      this.appState.endProcess("importing-data");
      await this.glossSyncService.logError([], error, "Saving institutions", null);
      return false;
    }
  }

  /*  async connectToInstitution(institutionId: string) {
    if (await this.isAuthenticated()) {
      const userToken = await this.getUserToken();
      const isConnectionOpen = await this.isConnectionOpen();
      if (isConnectionOpen) {
        /!*https://consent.basiq.io/home?token=${token}&action=${action}&state={yourState}&institutionId={institutionId}*!/
        window.location.href = `https://consent.basiq.io/home?&token=${userToken.token.access_token}&action=connect&state=sync&institutionId=${institutionId}`;
      }
    } else {
      await this.recurseIfAuthenticate(this.connectToAnotherInstitution.bind(this));
    }
  }*/
}
